export const CATEGORIAS = [
    "ALL",
    "CLIENTE",
    "COLABORADOR",
    "PROVEEDOR",
    "DIRECTOR",
];

export const TIPOS_PERSONA = [
    "ALL",
    "Person",
    "Entity",
];